var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23.9997,
    height: 24,
    rx: 2,
    fill: "#252525",
    fillOpacity: 0.75
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_181_1232",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_181_1232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 19.3002V17.9669C9.9444 17.8113 8.75284 17.2364 7.75862 16.2422C6.76395 15.2475 6.18884 14.0558 6.03328 12.6669H4.69995V11.3335H6.03328C6.18884 9.94464 6.76395 8.75286 7.75862 7.7582C8.75284 6.76397 9.9444 6.18908 11.3333 6.03353V4.7002H12.6666V6.03353C14.0555 6.18908 15.2473 6.76397 16.242 7.7582C17.2362 8.75286 17.8111 9.94464 17.9666 11.3335H19.3V12.6669H17.9666C17.8111 14.0558 17.2362 15.2475 16.242 16.2422C15.2473 17.2364 14.0555 17.8113 12.6666 17.9669V19.3002H11.3333ZM12 16.6669C13.2888 16.6669 14.3888 16.2113 15.3 15.3002C16.2111 14.3891 16.6666 13.2891 16.6666 12.0002C16.6666 10.7113 16.2111 9.61131 15.3 8.7002C14.3888 7.78908 13.2888 7.33353 12 7.33353C10.7111 7.33353 9.61106 7.78908 8.69995 8.7002C7.78884 9.61131 7.33328 10.7113 7.33328 12.0002C7.33328 13.2891 7.78884 14.3891 8.69995 15.3002C9.61106 16.2113 10.7111 16.6669 12 16.6669ZM12 14.6669C11.2666 14.6669 10.6388 14.4058 10.1166 13.8835C9.5944 13.3613 9.33328 12.7335 9.33328 12.0002C9.33328 11.2669 9.5944 10.6391 10.1166 10.1169C10.6388 9.59464 11.2666 9.33353 12 9.33353C12.7333 9.33353 13.3611 9.59464 13.8833 10.1169C14.4055 10.6391 14.6666 11.2669 14.6666 12.0002C14.6666 12.7335 14.4055 13.3613 13.8833 13.8835C13.3611 14.4058 12.7333 14.6669 12 14.6669ZM12 13.3335C12.3666 13.3335 12.6806 13.2029 12.942 12.9415C13.2028 12.6806 13.3333 12.3669 13.3333 12.0002C13.3333 11.6335 13.2028 11.3195 12.942 11.0582C12.6806 10.7973 12.3666 10.6669 12 10.6669C11.6333 10.6669 11.3195 10.7973 11.0586 11.0582C10.7973 11.3195 10.6666 11.6335 10.6666 12.0002C10.6666 12.3669 10.7973 12.6806 11.0586 12.9415C11.3195 13.2029 11.6333 13.3335 12 13.3335Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.6749cc9712cf21faf09d804ddf6dae25.svg";
export { ForwardRef as ReactComponent };